import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { WorkspaceWidget as mainModule } from './main';
import * as config from './config';
import * as mainTheme from './themes/main';

declare var require: any;
require('../sass-main/pdc-widget-workspace.sass');

import { HandlerDescriptions } from '../../../_common/platform/ts/WidgetBaseModule';

export class WorkspaceWidget extends WidgetBase {
    public static _name: string = config.name;
    public static group = config.group;
    public static moduleName: string = config.moduleName;
    public static icon: string = config.icon;
    public static themeModule = mainTheme;

    public static handlers: HandlerDescriptions = [
        {
            widgetType: 'pdc-widget-folder-ws',
            actionType: 'workspace-navigate'
        }
    ];

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-workspace'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(WorkspaceWidget);
